import moment from 'moment';
import { forEach } from 'lodash';

import { prettifyNumber } from 'application/util/number.util';
import { getErrorMessage } from 'application/util/error.util';

import './category-chart.style.sass';
import template from './category-chart.tpl.pug';

class CategoryChartController {
    /* @ngInject */
    constructor(dashboardService) {
        this.dashboardService = dashboardService;
        
        this.options = this.getChartOptions();
    }

    $onInit() {
        this.loading = true;
    }

    $onChanges(changeObject) {
        if (changeObject.calendarIds || changeObject.start || changeObject.end || changeObject.confirmed) {
            return this.load(
                this.calendarIds,
                moment(this.start).startOf('day').valueOf(),
                moment(this.end).endOf('day').valueOf(),
                this.confirmed
            );
        }
    }

    getTooltipLabel(item, data) {
        let index = item.index;
        let datasetIndex = item.datasetIndex;

        return prettifyNumber(data.datasets[datasetIndex].data[index], {
            preventShrink: true,
            pretty: true
        });
    }

    getBalanceTick(label) {
        return prettifyNumber(label);
    }

    getMonthTick(label) {
        return moment(label).format('MMM');
    }

    getChartOptions() {
        return {
            maintainAspectRatio: false,
            responsive: true,
            layout: {
                padding: {
                    top: 60
                }
            },
            tooltips: {
                yAlign: 'bottom',
                callbacks: {
                    label: this.getTooltipLabel.bind(this)
                }
            },
            scales: {
                xAxes: [{
                    position: 'top',
                    gridLines: {
                        color: '#ebeced',
                        borderDash: [3, 5],
                        drawBorder: false,
                        drawTicks: false
                    },
                    ticks: {
                        padding: 10,
                        suggestedMin: 0,
                        suggestedMax: 0,
                        beginAtZero: true,
                        maxTicksLimit: 5,
                        maxRotation: 0,
                        minRotation: 0,
                        callback: this.getBalanceTick.bind(this)
                    },
                }],
                yAxes: [{
                    gridLines: {
                        display: false,
                        color: '#ebeced',
                        drawTicks: false
                    },
                    ticks: {
                        padding: 15,
                        maxRotation: 0,
                        minRotation: 0
                    },
                    barPercentage: 0.25,
                    categoryPercentage: 1
                }]
            }
        };
    }

    load(calendarIds, start, end, confirmed) {
        start = moment(start);
        end = moment(end);

        this.loading = true;

        let labels = [];
        let values = [];
        let colors = [];

        return this.dashboardService.getExpenseCategoryData(
            calendarIds,
            start.isValid() ? start.valueOf() : null,
            end.valueOf(),
            confirmed
        ).then((dataSet) => {
            forEach(dataSet, (item) => {
                labels.push(item.category.name);
                colors.push(item.category.color);
                values.push(item.value);
            });

            this.error = null;
        }).catch((result) => {
            this.error = getErrorMessage(result, `Unfortunately we couldn't load the chart data. Please try again later.`);
        }).finally(() => {
            this.data = {
                labels,
                datasets: [
                    this.getDataSet(values, colors)
                ]
            };

            this.height = labels.length > 0
                ? `${labels.length * 30 + 10 + 15}px`
                : null;

            this.loading = false;
        });
    }

    getDataSet(data, colors) {
        return {
            data,
            fill: true,
            backgroundColor: colors,
            hoverBackgroundColor: colors
        };
    }
}

export default {
    selector: 'dbACategoryChart',
    template: template(),
    controller: CategoryChartController,
    bindings: {
        calendarIds: '<',
        start: '<',
        end: '<',
        confirmed: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/dashboard/component/category-chart/category-chart.cmpt.js